import { render, staticRenderFns } from "./createApprovalRule.vue?vue&type=template&id=d5224be8&scoped=true"
import script from "./createApprovalRule.vue?vue&type=script&lang=js"
export * from "./createApprovalRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5224be8",
  null
  
)

export default component.exports